module.exports = __webpack_public_path__ + "static/media/whatsapp.11216771.svg";